import React, { useEffect } from "react";
import { useFormContext, useController } from "react-hook-form";

interface PaziaToggleIconProps {
  name: string;
  onToggle?: (isChecked: boolean) => void;
  children?: React.ReactNode;
  enabledColor?: string;
  disabledColor?: string;
  hoverColor?: string;
}
export const PaziaToggleIcon = (props: PaziaToggleIconProps): JSX.Element => {
  const {
    name,
    onToggle,
    children,
    enabledColor = "text-emerald-500",
    disabledColor = "text-slate-300",
    hoverColor = "hover:text-emerald-500",
  } = props;
  const { control, getValues } = useFormContext();

  const { field } = useController({
    name,
    control,
  });

  useEffect(() => {
    if (field.value !== getValues(name)) field.onChange(getValues(name));
  }, [getValues(name)]);

  const onChangeHandler = (isChecked: boolean) => {
    field.onChange(isChecked);
    if (onToggle) onToggle(isChecked);
  };

  const childrenWithProps = React.Children.map(children, (child) => {
    if (React.isValidElement(child)) {
      return React.cloneElement(child, {
        ...props,
        // @ts-ignore
        onClick: () => onChangeHandler(!field.value),
        className: `cursor-pointer ${hoverColor} ${
          field.value ? enabledColor : disabledColor
        }`,
      });
    }
    return child;
  });

  return (
    <>
      <input
        type="checkbox"
        className="hidden"
        value={field.value ?? false}
        checked={field.value ?? false}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
          onChangeHandler(e.target.checked)
        }
      />
      {childrenWithProps}
    </>
  );
};
